module.exports = __webpack_public_path__ + "images/offline_ico.cb7fcade5d16591970d4a5cd3bfefe82.png";